import { Fragment } from 'react';

import Tooltip from '@gogame/ui/Tooltip';

import styled from '../../styled';
import LegacyBox from '../Box';
import LegacyText from '../Text';

const CustomText = styled(LegacyText)`
  word-break: break-all;
`;

const LegacyTextListItem = ({
  affix,
  affixStyles,
  suffix,
  suffixStyles,
  verticalAlign,
  justify,
  gutter,
  children,
  tooltip,
  tooltipPosition = 'bottom',
  index,
  wrap,
  withContentTooltip = true,
  ...props
}) => {
  const content = (
    <LegacyBox
      align={verticalAlign}
      justifyContent={justify}
      gutter={gutter}
      wrap={wrap}
    >
      {affix ? (
        <LegacyBox {...props} style={affixStyles}>
          {typeof affix === 'function' ? affix({ index: index }) : affix}
        </LegacyBox>
      ) : null}
      <CustomText {...props}>{children}</CustomText>
      {suffix ? (
        <LegacyBox {...props} style={suffixStyles}>
          {typeof suffix === 'function' ? suffix({ index: index }) : suffix}
        </LegacyBox>
      ) : null}
    </LegacyBox>
  );

  tooltip = tooltip || (withContentTooltip && children);
  return (
    <Fragment>
      {tooltip ? (
        <Tooltip text={tooltip} placement={tooltipPosition}>
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </Fragment>
  );
};

export default LegacyTextListItem;
